<template>
<div class="container pb-4">

  <div v-if="loading" class="text-center py-3"><i class="fas fa-spinner fa-spin"></i></div>

  <div v-else-if="itemCount == 0" class="text-center pb-3">
    <div class="card">
      <div class="card-body">
        <div>Cart is empty</div>
        <div><a class="btn btn-danger mt-3 px-3" href="/">Start shopping</a></div>
      </div>
    </div>
  </div>

    <div v-else>
    <div class="row">
        <div class="col"><div class="section-heading-md pt-0 pb-3">Review your order</div></div>
        <div class="col text-right"><a href="/cart"><i class="fas fa-shopping-basket mr-2"></i>Back to cart</a></div>
    </div>
    <div class="row">

      <div class="col-md-9">

        <div v-if="myAddresses">
          <my-addresses @close-addresses="closeAddresses" ref="Child"></my-addresses>
        </div>
        
        <div v-else>
          <div v-if="!address"><button class="btn btn-success col" @click="openAddresses">Choose a delivery address</button></div>
          <delivery-address v-else @open-addresses="openAddresses" :address="address" ref="DeliveryAddress"></delivery-address>
        </div>

      <payment-method></payment-method>
      </div>

      <div class="col-md-3" v-if="!myAddresses">

          <div class="card">
            <div class="card-body">
              <div><b>Cart summary</b></div>
              <div class="row mt-2">
                <div class="col">{{itemCount}} {{word}}</div>
                <div class="col text-right">R {{subTotal}}</div>
              </div>
              <div class="row mt-2">
                <div class="col">Delivery</div>
                <div class="col text-right">R {{deliveryFee}}</div>
              </div>
              <div class="row mt-2">
                <div class="col"><b>Total</b></div>
                <div class="col text-right"><b>R {{totalAmount}}</b></div>
              </div>
              <div v-if="itemCount > 0 && address" class="text-center">
                  <div v-if="loadingPayfast" class="py-2"><i class="fas fa-spinner fa-spin"></i></div>
                  <div v-else-if="payfastButton" class="mt-3" v-html="payfastButton"></div>
                  <div v-if="loadingOzow" class="py-2"><i class="fas fa-spinner fa-spin"></i></div>
                  <div v-else-if="ozowButton" class="mt-3" v-html="ozowButton"></div>
                </div>
            </div>
          </div>

          <div class="card mt-3">
            <div class="card-body">
              <div><b>Items in cart</b></div>
              <table class="table" style="line-height:1.2rem;">
              <tbody>
                <tr v-for="(item, index) in items" :key="index">
                    <td class="text-center">
                      <img v-if="item.product.images.length > 0" :src="item.product.images[0].url" style="height:2rem;" />
                      <img v-else src="/images/image-not-found.svg" style="height:2rem;" />
                      </td>
                    <td class="pl-3">
                        <div><b>{{item.product.name}}</b></div>
                        <div>Qty {{item.quantity}}</div>
                        <div>R {{Number(item.product.price) * Number(item.quantity)}}</div>
                    </td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>

      </div>
    </div>
    </div>
</div>
</template>

<script>
export default {

  data() {
    return {
      items: [],
      itemCount: 0,
      address: {},
      subTotal: 0,
      totalAmount: 0,
      deliveryFee: 0,
      deliveryBaseFee: 0,
      loading: false,
      myAddresses: false,
      payfastButton: null,
      ozowButton: null,
      loadingOzow: false,
      loadingPayfast: false,
    };
  },

  computed: {
    word() {
      return this.itemCount === 1 ? 'item' : 'items';
      }
  },

  created() {
    this.getDeliveryBaseFee();
    this.getSelectedAddress();
  },

  methods: {

    closeAddresses() {
      this.getSelectedAddress();
      this.myAddresses = false;
    },

    openAddresses() {
      this.myAddresses = true;
    },

    getDeliveryBaseFee() {
      axios
        .get('/delivery-fee')
        .then((response) => {
          this.deliveryBaseFee = response.data;
          this.getProducts();
        });
    },

    getSelectedAddress() {
      axios
        .get('/address/selected')
        .then((response) => {
          this.address = response.data;
        });
    },

    getProducts() {

      this.loading = true;

      axios
        .get('/cart/items')
        .then((response) => {
          this.items = response.data;
          this.countItems();
          this.getTotalAmount();
        });

    },

    getTotalAmount() {

      this.subTotal = this.items.reduce((total, item) => {
        return total + (item.product.price * item.quantity);
      }, 0);

      this.deliveryFee = this.items.length * this.deliveryBaseFee;

      this.totalAmount = this.subTotal + this.deliveryFee;
      
      this.getPayfastButton();
      this.getOzowButton();

    },

    countItems() {
      axios
        .get('/cart/item-count')
        .then((response) => {
          this.itemCount = response.data;
          this.loading = false;
        });
    },

    getPayfastButton() {
      this.loadingPayfast = true;
      axios
        .post('/payfast/button', {
          amount: this.totalAmount
        })
        .then((response) => {
          this.payfastButton = response.data;
          this.loadingPayfast = false;
        });
    },

    getOzowButton() {
      this.loadingOzow = true;
      axios
        .post('/ozow/button', {
          amount: this.totalAmount
        })
        .then((response) => {
          this.ozowButton = response.data;
          this.loadingOzow = false;
        });
    },

  },
};
</script> 
